import { useTranslation } from "@l2r-front/l2r-i18n"
import { Typography } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { ACCOUNT_PAGE, EMAIL_PAGE, PASSWORD_PAGE } from "../../../../common/constants/settings"
import { MobileAccountSettingsMenuItem } from "../../components/MobileAccountSettingsMenuItem"

import * as Styled from "./MobileAccountSettingsHomePage.styled"

export const MobileAccountSettingsHomePage = (props) => {
    const {
        changePage,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return (
        <Styled.AccountSettingsCategory>
            <Typography variant="Desktop & Mobile/Heading/H4">{t(I18N_NAMESPACE, "pages.accountSettings.profile.label")}</Typography>
            <Styled.AccountSettingsList>
                <MobileAccountSettingsMenuItem
                    label={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountInfoLabel")}
                    desc={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountInfoDesc")}
                    variant="secondary"
                    onClick={() => changePage(ACCOUNT_PAGE)}
                />
                <MobileAccountSettingsMenuItem
                    label={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountEmailLabel")}
                    desc={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountEmailDesc")}
                    variant="secondary"
                    onClick={() => changePage(EMAIL_PAGE)}
                />
                <MobileAccountSettingsMenuItem
                    label={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountPasswordLabel")}
                    desc={t(I18N_NAMESPACE, "pages.accountSettings.profile.accountPasswordDesc")}
                    variant="secondary"
                    onClick={() => changePage(PASSWORD_PAGE)}
                />
            </Styled.AccountSettingsList>
        </Styled.AccountSettingsCategory>
    )
}